<template>
  <div>
    <div
      class="common-book pt-12"
      ref="COMMONBOOK"
      id="COMMONBOOK"
      v-if="!isDisabled"
    >
      <div>
        <div
          class="item pl-12 bg-FFFFFF fb fb-main-between fb-cross-center bb hidden"
          v-if="queryType === 1"
        >
          <md-checkbox
            v-model="noticeBeSubstitutedTeacher"
            label="申请人"
            class="font-34 c-171A1D"
          ></md-checkbox>
        </div>
        <div
          class="item pl-12 bg-FFFFFF fb fb-main-between fb-cross-center bb hidden"
        >
          <md-checkbox
            v-model="noticeSubstituteTeacher"
            label="调/代课老师"
            class="font-34 c-171A1D"
          ></md-checkbox>
        </div>
        <div
          class="item pl-12 bg-FFFFFF fb fb-main-between fb-cross-center bb hidden"
        >
          <md-checkbox
            v-model="noticeAdviser"
            label="所在班级班主任"
            class="font-34 c-171A1D"
          ></md-checkbox>
        </div>
        <div
          class="item pl-12 bg-FFFFFF fb fb-main-between fb-cross-center bb hidden"
          v-if="queryType === 2"
        >
          <md-checkbox
            v-model="noticeAdmin"
            label="管理员"
            class="font-34 c-171A1D"
          ></md-checkbox>
        </div>
        <div
          class="item mb-12 border-0 h-56 mt-12 bg-FFFFFF p-0-16 p-16-0 font-34 c-006AFE pointer fb fb-main-start fb-cross-center"
          @click="chooseNoticePerson"
          v-if="!isDisabled"
        >
          <i class="iconfont mr-5">&#xe66c;</i>
          <span>添加通知对象</span>
        </div>
        <div
          class="pl-16 bg-FFFFFF p-10-0"
          v-for="(v, index) in noticeOtherUserDingIds"
          :key="index"
        >
          <div class="fb fb-main-between fb-cross-center pr-16">
            <div class="fb fb-main-start fb-cross-center">
              <div
                class="w-36 h-36 bg-006AFE bd-radio-9999 c-FFFFFF font-28 fb fb-main-center text-center fb-cross-center"
              >
                <span>{{ nameLastTwoWords(v.name) }}</span>
              </div>
              <span class="font-34 ml-12 mr-4">{{ v.name }}</span>
              <!-- <i class="iconfont c-FF4D94 font-34">&#xe686;</i> -->
            </div>
            <i
              class="iconfont font-34 c-171A1D-24"
              v-if="!isDisabled"
              @click="clear(index)"
              >&#xe670;</i
            >
          </div>
        </div>
      </div>
      <!-- 只读 -->
    </div>
    <div class="pt-12" ref="COMMONBOOK" id="COMMONBOOK" v-else>
      <div class="font-34 c-171A1D">
        <!--1 教务安排没有管理员 -->
        <!--2 自主安排没有申请人 -->
        <div
          class="item bg-FFFFFF fb fb-main-between fb-cross-center bb hidden pl-20"
          v-if="noticeBeSubstitutedTeacher && substituteWay === 1"
        >
          申请人
        </div>
        <div
          class="item bg-FFFFFF fb fb-main-between fb-cross-center bb hidden pl-20"
          v-if="noticeSubstituteTeacher"
        >
          调/代课老师
        </div>
        <div
          class="item bg-FFFFFF fb fb-main-between fb-cross-center bb hidden pl-20"
          v-if="noticeAdviser"
        >
          所在班级班主任
        </div>
        <div
          class="item bg-FFFFFF fb fb-main-between fb-cross-center bb hidden pl-20"
          v-if="noticeAdmin && substituteWay === 2"
        >
          管理员
        </div>
        <div
          class="pl-16 bg-FFFFFF p-10-0"
          v-for="(v, index) in noticeOtherUserDingIds"
          :key="index"
        >
          <div class="fb fb-main-between fb-cross-center pr-16">
            <div class="fb fb-main-start fb-cross-center">
              <div
                class="w-36 h-36 bg-006AFE bd-radio-9999 c-FFFFFF font-28 fb fb-main-center text-center fb-cross-center"
              >
                <span>{{ nameLastTwoWords(v.name) }}</span>
              </div>
              <span class="font-34 ml-12 mr-4">{{ v.name }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="!isDisabled"
      class="footer font-26 fb fb-main-start fb-cross-center h-60 bg-FFFFFF p-0-16 bt-8"
    >
      <common-button @click="handlerNoticeClose">确定</common-button>
    </div>
    <template
      v-if="
        isDisabled &&
        !noticeAdmin &&
        !noticeAdviser &&
        !noticeBeSubstitutedTeacher &&
        !noticeSubstituteTeacher &&
        !(noticeOtherUserDingIds || []).length
      "
    >
      <common-no-data class="no-record bg-F6F6F6">
        <div class="no-course no-item"></div>
        <p class="font-28 c-171A1D-40">暂无通知对象</p>
      </common-no-data>
    </template>
  </div>
</template>

<script>
import mixin from '@/mixin'
import commonNoData from './commonNoData'
import commonButton from './commonButton'
import { deepCopy, nameLastTwoWords } from '@/utils/comUtils'
export default {
  name: 'commonNotice',
  mixins: [mixin],
  components: {
    commonNoData,
    commonButton
  },
  props: {
    substituteWay: {
      type: Number,
      default: null
    },
    noticeConfig: {
      type: Object,
      default: null
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    queryType: {
      type: Number,
      default: 1
    }
  },
  data() {
    return {
      nameLastTwoWords,
      noticeAdmin: 1,
      noticeAdviser: 1,
      noticeBeSubstitutedTeacher: 1,
      noticeSubstituteTeacher: 1,
      scrollHeight: 0,
      noticeOtherUserDingIds: []
    }
  },
  created() {
    if (this.queryType === 1) {
      this.noticeAdmin = false
    } else {
      this.noticeBeSubstitutedTeacher = false
    }

    if (this.noticeConfig) {
      const {
        noticeAdmin,
        noticeAdviser,
        noticeBeSubstitutedTeacher,
        noticeSubstituteTeacher,
        noticeOtherUserDingIds,
        noticeOtherUsers = []
      } = deepCopy(this.noticeConfig)
      this.noticeAdmin = !!noticeAdmin
      this.noticeAdviser = !!noticeAdviser
      this.noticeBeSubstitutedTeacher = !!noticeBeSubstitutedTeacher
      this.noticeSubstituteTeacher = !!noticeSubstituteTeacher
      if (noticeOtherUsers.length) {
        noticeOtherUsers.map(v => {
          this.noticeOtherUserDingIds.push({
            name: v.userName,
            dingUserId: v.userDingId
          })
        })
      } else {
        this.noticeOtherUserDingIds = noticeOtherUserDingIds || []
      }
    }
    this.$nextTick(() => {
      this.methodToCalcScroll()
      this.$nextTick(() => {
        document.getElementById('COMMONBOOK').scrollTop = 0
      })
    })
  },
  methods: {
    clear(index) {
      this.noticeOtherUserDingIds.splice(index, 1)
    },
    handlerNoticeClose() {
      this.$emit('handlerNoticeClose', {
        noticeAdmin: this.noticeAdmin ? 1 : 0,
        noticeAdviser: this.noticeAdviser ? 1 : 0,
        noticeBeSubstitutedTeacher: this.noticeBeSubstitutedTeacher ? 1 : 0,
        noticeSubstituteTeacher: this.noticeSubstituteTeacher ? 1 : 0,
        noticeOtherUserDingIds: this.noticeOtherUserDingIds // 需要回显不能只穿ID
      })
    },
    chooseNoticePerson() {
      let _selected = this.noticeOtherUserDingIds.reduce((prev, next) => {
        return prev.concat(next.userId)
      }, [])
      try {
        let target = this.noticeOtherUserDingIds.map(v => v.dingUserId)
        let _addressBook = {
          sandboxId: this.$store.getters.orgSandboxId,
          multiple: true,
          returnType: 6,
          selectedMemberIds: _selected
        }
        this.$orgBook(_addressBook)
          .then(res => {
            if (res.$type !== 'onlyReturn') {
              ;(res.members || []).forEach(item => {
                if (!target.includes(item.userTpId)) {
                  this.noticeOtherUserDingIds.push({
                    name: item.userName,
                    dingUserId: item.userTpId,
                    userId: item.userId
                  })
                }
              })
            }
            this.handlerNoticeClose()
          })
          .catch(err => {
            console.log(err)
          })
      } catch (error) {
        console.log(error)
      }
    },
    methodToCalcScroll() {
      this.scrollHeight = this.$refs.COMMONBOOK.clientHeight - 100

      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.common-book {
  position: fixed;
  top: 0;
  width: 100%;
  left: 0;
  height: calc(100vh - 60px);
  overflow-y: scroll;
  z-index: 10;
}
.common-book > div {
  width: 100%;
}
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 100;
}
:deep(.md-tabbar) {
  overflow: inherit;
}
.item {
  cursor: pointer;
  padding-top: 13px;
  padding-bottom: 13px;
  height: 56px;
  .next {
    line-height: 30px;
    height: 30px;
    border-left: 1px solid rgba(17, 31, 44, 0.24);
    padding-left: 10px;
    text-align: left;
  }
  .people-avatar {
    width: 36px;
    height: 36px;
    line-height: 36px;
    background: #006afe;
    border-radius: 75px;
  }
  .people-status {
    height: 22px;
    line-height: 22px;
    background: rgba(255, 82, 25, 0.12);
    color: #ff5219;
  }
}
.no-record {
  .no-course {
    width: 180px;
    height: 180px;
    margin-bottom: 16px;
    &.no-item {
      background: url(~@/assets/images/no-data.png) no-repeat center top;
      background-size: 180px 180px;
    }
  }
}
</style>
